import cx from 'classnames'
import styles from './SquareIconButton.module.scss'

const SquareIconButton = ({ ariaLabel, className, disabled = false, Icon, onClick, variant }) => {
  return (
    <button
      type='button'
      aria-label={ariaLabel}
      className={cx(styles.button, styles[variant], className)}
      disabled={disabled}
      onClick={onClick}
    >
      <Icon
        aria-hidden='true'
        focusable='false'
        className={styles.icon}
      />
    </button>
  )
}

export default SquareIconButton
